"use client";

import Image from "next/image";

interface SoftCategoriesProps {
  categories: any[];
  activeCategory: string;
  setActiveCategory: (id: string) => void;
  subdomain: string;
}

export default function SoftCategories({
  categories,
  activeCategory,
  setActiveCategory,
  subdomain,
}: SoftCategoriesProps) {
  // ব্যাকএন্ডের রিলেটিভ বা অ্যাবসোলেট ইমেজ পাথ সঠিকভাবে রিসলভ করার ফাংশন
  const resolveImg = (url: string | null | undefined) => {
    if (!url) return null;
    if (url.startsWith("http://") || url.startsWith("https://")) return url;
    const cleanPath = url.startsWith("/") ? url : `/${url}`;
    return `http://${subdomain}.localhost:8000${cleanPath}`;
  };

  return (
    <section id="categories" className="max-w-7xl mx-auto px-4 sm:px-6">
      <div className="text-center mb-8">
        <h2 className="text-2xl font-black text-slate-900 tracking-tight">
          Popular Categories
        </h2>
        <p className="text-xs text-slate-500 mt-1">
          Browse our verified department collections
        </p>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-4 md:grid-cols-6 lg:grid-cols-8 gap-4">
        {/* All Items Button */}
        <button
          type="button"
          onClick={() => setActiveCategory("all")}
          className={`p-4 rounded-3xl transition-all text-center flex flex-col items-center justify-center gap-2.5 cursor-pointer border ${
            activeCategory === "all"
              ? "bg-blue-600 text-white shadow-xl shadow-blue-500/30 border-blue-600 -translate-y-1"
              : "bg-white text-slate-700 shadow-[6px_6px_14px_#dce5ef,-6px_-6px_14px_#ffffff] border-white hover:-translate-y-1"
          }`}
        >
          <div className="w-14 h-14 rounded-2xl flex items-center justify-center bg-blue-50 text-blue-600 shadow-inner font-black text-xl flex-shrink-0">
            ★
          </div>
          <span className="text-xs font-bold truncate max-w-full">All Items</span>
        </button>

        {/* Dynamic Categories Loop */}
        {categories.map((c: any) => {
          const isSelected = String(activeCategory) === String(c.id);
          const rawImg = c.image
          const imageUrl = resolveImg(rawImg);

          return (
            <button
              key={c.id || c.name}
              type="button"
              onClick={() => setActiveCategory(String(c.id))}
              className={`p-4 rounded-3xl transition-all text-center flex flex-col items-center justify-center gap-2.5 cursor-pointer border ${
                isSelected
                  ? "bg-blue-600 text-white shadow-xl shadow-blue-500/30 border-blue-600 -translate-y-1"
                  : "bg-white text-slate-700 shadow-[6px_6px_14px_#dce5ef,-6px_-6px_14px_#ffffff] border-white hover:-translate-y-1"
              }`}
            >
              <div className="w-14 h-14 rounded-2xl overflow-hidden shadow-sm bg-slate-100 flex items-center justify-center flex-shrink-0 relative">
                {imageUrl && !imageUrl.includes("emoji") ? (
                  <Image
                    src={c.image}
                    alt={c.name}
                    fill
                    sizes="56px"
                    unoptimized
                    className="object-cover"
                  />
                ) : (
                  <span className="text-xl font-bold text-blue-600">
                    {c.icon && !c.icon.startsWith("http") ? c.icon : c.name ? c.name.charAt(0) : "🛍️"}
                  </span>
                )}
              </div>
              <span className="text-xs font-bold truncate max-w-full">{c.name}</span>
            </button>
          );
        })}
      </div>
    </section>
  );
}